export { default } from '@material-ui/core/IconButton';

export type IconButtonProps = import('@material-ui/core/IconButton').IconButtonProps;
